import { messages } from '../messages';
import { isSearchRefined } from 'Src/utils/search-common';
import { getQueryParams } from 'Src/utils/url';

/**
 * Determines the appropriate message descriptor and test ID for search summary
 * @param {string} queryString - The search query string
 * @param {string|null} locationName - The location name for map-type searches
 * @param {boolean} showSearchDescription - Whether to show search description
 * @returns {Object} Object containing messageDescriptor and testId
 */
export function getSearchSummaryMessage(
  queryString: string,
  locationName: string | null | undefined,
  showSearchDescription: boolean
) {
  const queryParams = getQueryParams(queryString);
  const shouldShowRefinedSearch = isSearchRefined(queryString);
  const mapTypeSearch = locationName != null;

  if (mapTypeSearch === true) {
    if (showSearchDescription) {
      return {
        messageDescriptor: messages.foundfor,
        testId: 'messages-foundfor'
      };
    }
    return {
      messageDescriptor: messages.found,
      testId: 'messages-found'
    };
  }

  if (showSearchDescription && queryParams.location != null) {
    return {
      messageDescriptor: messages.foundfornear,
      testId: 'messages-foundfornear'
    };
  } else if (showSearchDescription && shouldShowRefinedSearch) {
    return {
      messageDescriptor: messages.foundForRefined,
      testId: 'messages-foundfor-refined'
    };
  } else if (showSearchDescription) {
    return {
      messageDescriptor: messages.foundfor,
      testId: 'messages-foundfor'
    };
  } else if (queryParams.location != null) {
    return {
      messageDescriptor: messages.foundnear,
      testId: 'messages-foundnear'
    };
  } else {
    return {
      messageDescriptor: messages.found,
      testId: 'messages-found'
    };
  }
}
